module.exports = __webpack_public_path__ + "static/media/US_vs_Austria_OR.2a20161b.jpg";